import { apInvoicesContracts } from "./ap-invoices.contract";
import { suppliersContracts } from "./suppliers.contract";
import { purchaseOrdersContracts } from "./purchase-orders.contract";
import { scheduledPaymentsContracts } from "./scheduled-payments.contract";
import { documentSearchContracts } from "./document-search.contract";

export const accountsPayableContracts = {
  invoices: apInvoicesContracts,
  suppliers: suppliersContracts,
  purchaseOrders: purchaseOrdersContracts,
  scheduledPayments: scheduledPaymentsContracts,
  documentSearch: documentSearchContracts,
} as const;

export * from "./ap-invoices.contract";
export * from "./purchase-orders.contract";
export * from "./suppliers.contract";
export * from "./scheduled-payments.contract";
export * from "./document-search.contract";
